import React from 'react'
import { useSelector } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'
import { ADMIN } from '../../constants/userRoles'

const PublicRoute = ({ ...routeProps }) => {
  const { isAuth, user } = useSelector((state) => state.auth)
  const redirectTo = user?.role === ADMIN ? '/admin' : '/app'
  return <>{isAuth ? <Redirect to={redirectTo} /> : <Route {...routeProps} />}</>
}

export default PublicRoute
